// Independent section components: no navigation and no shared rendering dependency.
if (!customElements.get('focusync-video-player')) {
  customElements.define('focusync-video-player', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const video = this.querySelector('video');
      const button = this.querySelector('[data-video-pause]');
      if (!video) return;
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) video.pause();
      if (!button) return;
      const update = () => {
        button.textContent = video.paused ? button.dataset.play : button.dataset.pause;
        button.setAttribute('aria-pressed', String(video.paused));
      };
      button.addEventListener('click', () => {
        if (video.paused) video.play().catch(update);
        else video.pause();
      }, {signal});
      video.addEventListener('play', update, {signal});
      video.addEventListener('pause', update, {signal});
      update();
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}

if (!customElements.get('focusync-formula-section')) {
  customElements.define('focusync-formula-section', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const controller = document.querySelector('focusync-controller');
      this.formula = controller?.state?.formula || new URLSearchParams(location.search).get('formula') || controller?.dataset.product || 'focus';
      this.detail = controller?.dataset.mode === 'detail' || Boolean(controller?.dataset.product) || location.search.includes('view=focusync-detail');
      this.editorSelected = false;
      this.update();
      document.addEventListener('focusync:formula-change', e => {
        this.formula = e.detail.formula;
        this.detail = e.detail.detail;
        this.update();
      }, {signal});
      const section = this.closest('.shopify-section');
      const select = e => {
        if (e.target !== section && !this.contains(e.target)) return;
        this.editorSelected = true;
        this.update();
      };
      const deselect = e => {
        if (e.target !== section && !this.contains(e.target)) return;
        this.editorSelected = false;
        this.update();
      };
      document.addEventListener('shopify:section:select', select, {signal});
      document.addEventListener('shopify:block:select', select, {signal});
      document.addEventListener('shopify:section:deselect', deselect, {signal});
      this.querySelectorAll('[data-formula-purchase]').forEach(button => {
        button.addEventListener('click', () => document.dispatchEvent(new CustomEvent('focusync:purchase', {detail: {formula: button.dataset.formulaPurchase}})), {signal});
      });
      this.querySelectorAll('video[autoplay]').forEach(video => {
        if (matchMedia('(prefers-reduced-motion: reduce)').matches) video.pause();
      });
    }
    update() {
      const visible = this.dataset.visibility !== 'selected' || (this.detail && this.formula === this.dataset.formula) || this.editorSelected;
      this.hidden = !visible;
      if (!visible) this.querySelectorAll('video').forEach(video => video.pause());
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}

if (!customElements.get('focusync-product-gallery')) {
 customElements.define('focusync-product-gallery', class extends HTMLElement {
  connectedCallback() {
   this.abort?.abort(); this.abort=new AbortController(); const signal=this.abort.signal;
   this.track=this.querySelector('.fc-buy-track'); this.thumbs=this.querySelector('.fc-buy-thumbnails');
   this.dialog=this.querySelector('.fc-photo-dialog');
   this.track.addEventListener('click',e=>{const button=e.target.closest('[data-photo-enlarge]');if(!button||!this.dialog)return;const slide=button.closest('figure');const source=slide.querySelector('img');const image=this.dialog.querySelector('[data-photo-full]');image.src=source.src;image.alt=source.alt;image.classList.toggle('fc-photo-monochrome',slide.classList.contains('fc-photo-monochrome'));this.dialog.querySelector('[data-photo-full-caption]').textContent=slide.dataset.photoCaption||'';this.dialog.showModal();},{signal});
   this.querySelector('[data-photo-close]')?.addEventListener('click',()=>this.dialog.close(),{signal});
   this.dialog?.addEventListener('click',e=>{if(e.target===this.dialog)this.dialog.close();},{signal});
   const controller=document.querySelector('focusync-controller');
   this.show(controller?.state?.formula || new URLSearchParams(location.search).get('formula') || 'focus');
   document.addEventListener('focusync:formula-change',e=>this.show(e.detail.formula),{signal});
   this.querySelector('[data-photo-prev]').addEventListener('click',()=>this.go(this.index-1),{signal});
   this.querySelector('[data-photo-next]').addEventListener('click',()=>this.go(this.index+1),{signal});
   this.track.addEventListener('scroll',()=>this.sync(),{signal,passive:true});
   this.track.addEventListener('keydown',e=>{if(['ArrowLeft','ArrowRight'].includes(e.key)){e.preventDefault();this.go(this.index+(e.key==='ArrowRight'?1:-1));}},{signal});
   let drag=null;
   this.track.addEventListener('pointerdown',e=>{if(e.pointerType==='mouse'&&e.button===0)drag={x:e.clientX,left:this.track.scrollLeft};},{signal});
   window.addEventListener('pointermove',e=>{if(drag){this.track.scrollLeft=drag.left+drag.x-e.clientX;}},{signal});
   window.addEventListener('pointerup',()=>{if(drag){drag=null;this.go(this.index);}},{signal});
   this.track.addEventListener('dragstart',e=>e.preventDefault(),{signal});
   this.resize=new ResizeObserver(()=>this.sync());this.resize.observe(this.track);
  }
  show(formula) {
   if(this.formula===formula)return;this.formula=formula;this.dialog?.close();
   const template=this.querySelector(`template[data-photo-formula="${formula}"]`);if(!template)return;
   this.track.replaceChildren(template.content.cloneNode(true));this.track.scrollLeft=0;
   this.slides=[...this.track.children];this.index=0;this.thumbs.replaceChildren();
   this.slides.forEach((slide,i)=>{const source=slide.querySelector('img');if(!source)return;source.loading=i?'lazy':'eager';const b=document.createElement('button');b.type='button';b.classList.toggle('fc-photo-monochrome',slide.classList.contains('fc-photo-monochrome'));b.setAttribute('aria-label',slide.dataset.photoCaption||'Photo '+(i+1));const img=source.cloneNode();img.removeAttribute('srcset');img.removeAttribute('sizes');const url=new URL(source.src);url.searchParams.set('width','120');img.src=url.href;img.alt='';img.loading='lazy';b.append(img);b.addEventListener('click',()=>this.go(i),{signal:this.abort.signal});this.thumbs.append(b);});
   this.sync();
  }
  go(index) {const target=this.slides[Math.max(0,Math.min(this.slides.length-1,index))];if(target)this.track.scrollTo({left:target.offsetLeft-this.slides[0].offsetLeft,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});}
  sync() {
   if(!this.slides?.length)return;
   this.index=this.slides.reduce((best,s,i)=>Math.abs(s.offsetLeft-this.slides[0].offsetLeft-this.track.scrollLeft)<Math.abs(this.slides[best].offsetLeft-this.slides[0].offsetLeft-this.track.scrollLeft)?i:best,0);
   this.querySelector('[data-photo-count]').textContent=String(this.index+1).padStart(2,'0')+' / '+String(this.slides.length).padStart(2,'0');
   const caption=this.querySelector('[data-photo-caption-current]');if(caption)caption.textContent=this.slides[this.index].dataset.photoCaption||'';
   this.querySelector('[data-photo-prev]').disabled=this.index===0;
   this.querySelector('[data-photo-next]').disabled=this.index===this.slides.length-1;
   this.thumbs.querySelectorAll('button').forEach((b,i)=>b.setAttribute('aria-pressed',String(i===this.index)));
   this.querySelector('.fc-buy-gallery-controls').hidden=this.slides.length<2;this.thumbs.hidden=this.slides.length<2;
  }
  disconnectedCallback(){this.abort?.abort();this.resize?.disconnect();}
 });
}
